import React, {type PropsWithChildren, useMemo} from 'react';

import cs from 'classnames';

import {
  DEFAULT_LOGO_URL,
  getLogoURL,
} from 'app/general/structures/SPFrame/SPHeader/CompanyLogo';
import {useAccountSettingsState} from 'app/settings/api';
import {gt} from 'app/utils/i18n';

import {ThemeCard} from './ThemeCard';

import type {KBThemeSerializedType} from 'sweet-types';

type Props = PropsWithChildren<{
  theme?: KBThemeSerializedType | null;
  kbName: string;
  isSelected: boolean;
}>;

export function ViewThemeMeta({children, theme, kbName, isSelected}: Props) {
  if (theme == null) {
    return <span>{gt('Sweet Default Theme')}</span>;
  }

  const settings = useAccountSettingsState().data;
  const {
    company_logo = DEFAULT_LOGO_URL,
    MEDIA_URL_READ = '',
    STATIC_URL = '/site_media/static/',
  } = settings == null ? {} : settings;

  const logo = useMemo(
    () => getLogoURL({company_logo, MEDIA_URL_READ, STATIC_URL}),
    [company_logo]
  );

  return (
    <ThemeCard
      theme={theme}
      logo={logo}
      kbName={kbName}
      className={cs({'border-dark': isSelected})}
    >
      {children}
    </ThemeCard>
  );
}
